/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useEffect, useState } from "react";
import RegisterPageMeta from "./RegisterPageMeta";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import registerPageStyle from "./registerPageStyle";
import Container from "@/src/components/Container/Container";
import AdvantagesBox from "@/src/components/Box/AdvantagesBox/AdvantagesBox";
import Paper from "@mui/material/Paper";
import { useLocation, useNavigate } from "react-router";
import AuthAction from "@/src/components/Auth/AuthAction";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import { Box } from "@mui/material";
import { translate } from "@/src/services/translations/translations";

export default function RegisterPage() {
  const [loginHeadline, setLoginHeadline] = useState("Registrieren");
  const { isLoggedIn } = useCustomer();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn) {
      const { from } = location.state || { from: { pathname: "/servicewelt" } };
      navigate(from.pathname);
    }
  }, [isLoggedIn]);

  return (
    <LayoutPublicRoutes minimal={true}>
      <RegisterPageMeta />
      <Box sx={registerPageStyle.background}>
        <Container sx={registerPageStyle.loginContainer}>
          <Paper elevation={4}>
            <Box sx={registerPageStyle.loginTitle}>{loginHeadline}</Box>
            <Box sx={registerPageStyle.loginContent}>
              <AuthAction onActionTypeChange={(actionType) => setLoginHeadline(translate("auth." + actionType, {}))} actionType={"register"} />
            </Box>
          </Paper>
        </Container>
      </Box>
      <Container showVerticalPadding={true}>
        <Box sx={{ display: { xs: "none", lg: "block" } }}>
          <AdvantagesBox />
        </Box>
      </Container>
    </LayoutPublicRoutes>
  );
}
